var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,21.35 L10.55,20.03 C5.4,15.36 2,12.28 2,8.5 C2,5.42 4.42,3 7.5,3 C9.24,3 10.91,3.81 12,5.09 C13.09,3.81 14.76,3 16.5,3 C19.58,3 22,5.42 22,8.5 C22,12.28 18.6,15.36 13.45,20.04 L12,21.35 Z",
    stroke: "#FF8C42",
    strokeWidth: 2,
    fill: "#FF8C42",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,8 L17,8",
    stroke: "#FF8C42",
    strokeWidth: 2,
    strokeDasharray: "2,2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,12 L17,12",
    stroke: "#FF8C42",
    strokeWidth: 2,
    strokeDasharray: "2,2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,16 L17,16",
    stroke: "#FF8C42",
    strokeWidth: 2,
    strokeDasharray: "2,2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 8,
    r: 1.5,
    fill: "#FF8C42"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 8,
    r: 1.5,
    fill: "#FF8C42"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 12,
    r: 1.5,
    fill: "#FF8C42"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 12,
    r: 1.5,
    fill: "#FF8C42"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 16,
    r: 1.5,
    fill: "#FF8C42"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 16,
    r: 1.5,
    fill: "#FF8C42"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDating);
export default __webpack_public_path__ + "static/media/dating.fbdcd8acef0ddb21b884243f91fdae53.svg";
export { ForwardRef as ReactComponent };